import React, {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClose} from "@fortawesome/free-solid-svg-icons";

const TagsInput = ({name, title, value = [], options = [], onChange}) => {
    const tags = Array.isArray(value) ? value : [];
    const [isOptionsVisible, setIsOptionsVisible] = useState(false);

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            const newTag = e.target.value.trim();
            if (newTag) {
                addTag(newTag);
            }
            e.target.value = "";
        }
    };

    const addTag = (tag) => {
        if (tag && !tags.includes(tag)) {
            const updatedTags = [...tags, tag];
            // 3. Just call the parent onChange
            if (onChange) {
                onChange(updatedTags);
            }
        }
    }

    const removeTag = (index) => {
        const updatedTags = tags.filter((_, i) => i !== index);
        if (onChange) {
            onChange(updatedTags);
        }
    };

    return (
        <div className="mb-4">
            <div className="flex flex-wrap items-center gap-2 bg-light-bg border-2 border-gray-200 rounded-md p-2 rtl">
                {tags.map((tag, index) => (
                    <div key={index} className="flex items-center bg-gray-300 text-black px-2 py-2 rounded-sm gap-x-2">
                        <span className='relative'>{tag}</span>
                        <button
                            className="mr-3 p-1 rounded-sm bg-white text-black flex relative hover:text-red-500"
                            onClick={() => removeTag(index)}
                        >
                            <FontAwesomeIcon icon={faClose}/>
                        </button>
                    </div>
                ))}
                <input
                    type="text"
                    className="border-none focus:outline-none p-2 flex-1"
                    placeholder={title}
                    onChange={onChange}
                    onFocus={() => {
                        setIsOptionsVisible(true)
                    }}
                    onKeyDown={handleKeyDown}
                />
            </div>
            <div
                className={`flex-col items-center gap-2 justify-center p-3 bg-gray-200 rounded-md ${isOptionsVisible ? 'flex' : 'hidden'}`}>
                {
                    options.map((option, index) => (
                        <span className="px-5 py-2 rounded-md text-md transition hover:bg-gray-200" key={index}
                              onClick={() => {
                                  addTag(option)
                              }}>{option}</span>
                    ))
                }
            </div>
        </div>
    );
};

export default TagsInput;
